if (!customElements.get('trust-indicators-slider')) {
  class TrustIndicatorsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      this.slider = new Swiper(this, {
        slidesPerView: 1.1,
        navigation: {
          nextEl: '.trust__swiper-button--next',
          prevEl: '.trust__swiper-button--prev',
        },

        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: 3,
            loop: false,
            navigation: {
              nextEl: '.trust__swiper-button--next',
              prevEl: '.trust__swiper-button--prev',
            }
          }
        }
      });
    }
  }

  customElements.define('trust-indicators-slider', TrustIndicatorsSlider);
}
